import React, { ReactNode } from 'react';
import { Box, SimpleGrid, Heading, useColorModeValue } from '@chakra-ui/react';

interface ProductionSectionProps {
    // title: string;
    akumulasiComponent: ReactNode;
    akumulasiComponent2?: ReactNode;
    harianComponent: ReactNode;
    spacing?: number | string;
    mb?: number | string;
}

/**
 * ProductionSection - Wrapper component untuk section produksi
 * Menggunakan layout 1:2 (akumulasi : harian)
 */
const ProductionSection: React.FC<ProductionSectionProps> = ({
    // title,
    akumulasiComponent,
    akumulasiComponent2,
    harianComponent,
    spacing = 4,
    mb = 6
}) => {
    const bgColor = useColorModeValue('white', 'gray.800');
    // const titleColor = useColorModeValue('gray.800', 'white');

    return (
        <Box mb={mb}>
            {/* <Heading 
                size="md" 
                mb={4} 
                color={titleColor}
                px={4}
            >
                {title}
            </Heading> */}
            <SimpleGrid
                templateColumns={{ base: "1fr", md: "1fr 2fr" }}
                spacing={spacing}
            >
                <Box
                    bg={bgColor}
                    rounded="lg"
                    shadow="md"
                    overflow="hidden"
                    display="flex"
                    flexDirection="column"
                >
                    {akumulasiComponent}
                </Box>
                <Box
                    bg={bgColor}
                    rounded="lg"
                    shadow="md"
                    overflowX="auto" 
                    overflowY="hidden"
                    display="flex"
                    flexDirection="column"
                >
                    {harianComponent}
                </Box>
                <Box
                    bg={bgColor}
                    rounded="lg"
                    shadow="md"
                    overflow="hidden"
                    display="flex"
                    flexDirection="column"
                >
                    {akumulasiComponent2}
                </Box>
            </SimpleGrid>
        </Box>
    );
};

export default ProductionSection;
